/**
 * Datas e linhas prontas do portal, no fuso da clínica de cada item (RT-21). Datas sem hora
 * (`aaaa-mm-dd`) não passam por fuso.
 */

const MONTHS = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ']

/** "2026-08-12" → "12/08/2026", sem passar por fuso. */
export function isoToBrDate(iso: string | null | undefined): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso ?? '')
  return match ? `${match[3]}/${match[2]}/${match[1]}` : ''
}

/** "2026-08-12" → "12 AGO 2026", para o olho de uma linha. */
export function dateEyebrow(iso: string | null | undefined): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso ?? '')
  if (!match) return ''
  const month = MONTHS[Number(match[2]) - 1] ?? match[2]
  return `${match[3]} ${month} ${match[1]}`
}

/** "2026-04-28T12:51:00Z" no fuso da clínica → { date: "28/04/2026", time: "09:51" }. */
export function formatDateTimeIn(iso: string, timeZone: string): { date: string; time: string } {
  const d = new Date(iso)
  const date = new Intl.DateTimeFormat('pt-BR', {
    timeZone,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(d)
  const time = new Intl.DateTimeFormat('pt-BR', {
    timeZone,
    hour: '2-digit',
    minute: '2-digit',
  }).format(d)
  return { date, time }
}

/** "2026-04-28T12:51:00Z" no fuso da clínica → "2026-04-28", para o olho da ficha. */
export function isoDateIn(iso: string, timeZone: string): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date(iso))
}

/** "Santo André/SP"; só a cidade quando não há UF. */
export function cityLine(clinic: { city?: string | null; state?: string | null }): string {
  return [clinic.city, clinic.state].filter(Boolean).join('/')
}
